export default {
  hintTitle: {
    id: 'swap_details_hint_title',
    defaultMessage: 'Why should you tell the truth?',
  },
  hint: {
    id: 'swap_details_hint',
    defaultMessage:
      'Each product is verified once arrived at the factory. If one of the information you gave is wrong, the merchant will send you a counter-offer. If you refuse it, the product will be sent back to you at your charge.',
  },
  getEstimation: {
    id: 'buyback_swap_details_get_estimation',
    defaultMessage: 'See the estimation',
  },
}
